import React, { useContext, useState } from "react";
import EmailVerificationContext from "./index";
import AuthorizationContext from "../Authorization/index";
import axiosConfig from "../../Config/axios";
import { getSecureAuthenticationRoute } from "../../Route/RouteIndex";
import type { EmailVerificationContextType, EmailVerificationProviderProps } from "./EmailVerificationTypes";

const EmailVerificationProvider: React.FC<EmailVerificationProviderProps> = (props) => {
    const [isDismissed, setIsDismissed] = useState<boolean>(false);
    const authorizationContext = useContext(AuthorizationContext);

    const refreshVerificationStatus = async (): Promise<void> => {
        try {
            const response = await axiosConfig.get(
                getSecureAuthenticationRoute('initial-session')
            );

            if (response?.data?.data && authorizationContext?.setAuthorizedUser) {
                authorizationContext.setAuthorizedUser(response.data.data);

                // If email is now verified, dismiss the popup
                if (response.data.data.email_verified) {
                    setIsDismissed(true);
                }
            }
        } catch (error) {
            console.error("Error refreshing verification status:", error);
        }
    };

    const contextValue: EmailVerificationContextType = {
        isDismissed,
        setIsDismissed,
        refreshVerificationStatus,
        ...props,
    };

    return (
        <EmailVerificationContext.Provider value={contextValue}>
            {props.children}
        </EmailVerificationContext.Provider>
    );
};

export default EmailVerificationProvider;


